import React from 'react';
import './Home.css'
import NavBar from '../Components/Layout/NavBar';
import HeroContent from '../Components/Layout/HeroContent';
import Stat from '../Components/Common/Stat';
import SecTitle from '../Components/Common/SecTitle';
import SecSub from '../Components/Common/SecSub';
import AboutP from '../Components/Layout/AboutP';
import AboutImg from '../Assets/AboutImg.png'
import GoalCard from '../Components/Common/GoalCard';
import TeamCard from '../Components/Common/TeamCard';
import Team1 from '../Assets/Team1.png'
import Team2 from '../Assets/Team2.png'
import Team3 from '../Assets/Team3.png'
import Team4 from '../Assets/Team4.png'
import FAQ from '../Components/Common/FAQ';
import ContactInfo from '../Components/Layout/ContactInfo';
import ContactForm from '../Components/Layout/ContactForm';
import Logo from '../Components/Common/Logo';
import FNavLink from '../Components/Common/FNavLink';

const Home = () => {
    return ( 
        <div className='Main' id='Main'>
        <header>
            <NavBar />
        </header>
        
        <section className='Hero'>
            <HeroContent />
        </section>

        <section className='Stats'>
            <Stat StatNum="500+" StatName="Clients Represented" StatSub="Trusted by individuals and businesses across diverse legal matters."/>
            <Stat StatNum="95%" StatName="Client Satisfaction" StatSub="Consistently delivering clarity, guidance, and positive outcomes."/>
            <Stat StatNum="20+ Years" StatName="Combined Experience" StatSub="Deep expertise across multiple practice areas."/>
            <Stat StatNum="150+" StatName="Successful Cases" StatSub="Proven track record of strategic advocacy and strong results."/>
        </section>

        <section className='About'>
            <div className='SecHeader'>
                <SecTitle TitleText="About Us"/>
                <SecSub SecSub="Dedicated to clarity, integrity, and results, every step of the way."/>
            </div>
            
            <div className='AboutContent'>
                <div className='AboutText'>
                    <AboutP AboutPText="At our firm, we believe the law is more than statutes and procedures—it's a tool for protecting people, solving problems, and shaping better futures. Every case we take on is guided by our core values: integrity, clarity, and unwavering commitment to our clients."/>
                    <AboutP AboutPText="With years of combined experience across a wide range of practice areas, our attorneys bring both strategic insight and practical solutions to every matter. We take the time to understand your goals, explain your options, and build a legal strategy tailored to your unique situation."/>
                    <AboutP AboutPText="Whether you're facing a challenging dispute, planning ahead, or navigating a complex legal process, we're here to stand by your side. Our mission is simple: to provide exceptional representation with professionalism you can trust."/>
                </div>

                <img className='AboutImg' src={AboutImg} alt="" />
            </div>
        </section>

        <section className='Goal'>
            <div className='SecHeader'>
                <SecTitle TitleText="Our Goal"/>
                <SecSub SecSub="Guided by purpose. Driven by results."/>
            </div>

            <div className='GoalCards'>
                <GoalCard GCardTitle="Our Mission" GCardP="Our mission is to provide exceptional legal representation built on integrity, dedication, and deep understanding. We strive to advocate for our clients with clarity and confidence, delivering strategic solutions that protect their rights and support their long-term goals. Every case we handle reflects our commitment to professionalism, transparency, and meaningful results."/>
                <GoalCard GCardTitle="Our Vision" GCardP="We envision a future where every client feels empowered, informed, and confident in their legal journey. Our goal is to be recognized not only for winning cases, but for transforming the attorney-client relationship through transparency, accessibility, and unwavering dedication to justice."/>
                <GoalCard GCardTitle="Our Values" GCardP="Integrity guides everything we do. We believe in honest communication, ethical practice, and treating every client with respect and dignity. Our values include accountability, excellence, compassion, and an unwavering commitment to upholding the law while fighting for what's right."/>
            </div>
        </section>

        <section className='Team'>
            <div className='SecHeader'>
                <SecTitle TitleText="Our Team"/>
                <SecSub SecSub="Meet the dedicated professionals committed to your success"/>
            </div>

            <div className='TeamCards'>
                <TeamCard TeamImg={Team1} TeamName="Sarah Mitchell" TeamPos="Managing Partner" TeamSub="Corporate Law & Litigation"/>
                <TeamCard TeamImg={Team2} TeamName="David Chen" TeamPos="Senior Partner" TeamSub="Family Law & Estate Planning"/>
                <TeamCard TeamImg={Team3} TeamName="Emily Rodriguez" TeamPos="Partner" TeamSub="Criminal Defense & Appeals"/>
                <TeamCard TeamImg={Team4} TeamName="Marcus Thompson" TeamPos="Associate Attorney" TeamSub="Real Estate & Contract Law"/>
            </div>
        </section>

        <section className='FAQ'>
            <div className='SecHeader'>
                <SecTitle TitleText="Frequently Asked Questions"/>
                <SecSub SecSub="Common questions about our legal services"/>
            </div>

            <div className='FAQs'>
                <FAQ question="What areas of law does your firm practice?" answer="We offer comprehensive legal services across multiple practice areas including corporate law, family law, criminal defense, real estate, estate planning, and civil litigation. Our diverse team of attorneys ensures specialized expertise for every client need."/>
                <FAQ question="How do you charge for your services?" answer="Our fee structure varies depending on the type of case and service required. We offer hourly billing, flat fees for specific services, and contingency arrangements where appropriate. During your initial consultation, we'll provide transparent pricing tailored to your situation."/>
                <FAQ question="How long does a typical case take?" answer="The timeline varies significantly based on case complexity, jurisdiction, and whether settlement is reached. Simple matters may resolve in weeks, while complex litigation can take months or years. We provide realistic timelines during consultation and keep you informed throughout the process."/>
                <FAQ question="Do you offer free consultations?" answer="Yes, we offer complimentary initial consultations to discuss your legal needs, evaluate your case, and determine how we can best serve you. This no-obligation meeting allows us to understand your situation and provide preliminary guidance."/>
                <FAQ question="How can I prepare for my first meeting?" answer="Bring any relevant documents related to your case, including contracts, correspondence, court papers, or records. Prepare a timeline of events and a list of questions. The more information you provide, the better we can assess your situation and develop an effective strategy."/>
            </div>
        </section>

        <section className='Contact'>
            <div className='SecHeader'>
                <SecTitle TitleText="Get In Contact"/>
                <SecSub SecSub="Schedule your consultation today"/>
            </div>

            <div className='ContactContent'>
                <ContactInfo />
                <ContactForm />
            </div>
        </section>

        <footer>
            <div className='FooterTop'>
                <div className='FCol'>
                    <Logo />
                    <p className='FooterP'>
                        Excellence in every case. A boutique legal practice offering refined expertise, personalized strategy, and results that matter.
                    </p>
                </div>
                <div className='FCol'>
                    <p className='ColTitle'>Quick Links</p>
                    
                    <div className='FNav'>
                        <FNavLink FNavText="Home"/>
                        <FNavLink FNavText="About Us"/>
                        <FNavLink FNavText="Our Team"/>
                        <FNavLink FNavText="FAQ"/>
                        <FNavLink FNavText="Contact"/>
                    </div>
                </div>

                <div className='FCol'>
                    <p className='ColTitle'>Practice Areas</p>
                    
                    <div className='FNav'>
                        <FNavLink FNavText="Corporate Law"/>
                        <FNavLink FNavText="Family Law"/>
                        <FNavLink FNavText="Criminal Defense"/>
                        <FNavLink FNavText="Real Estate"/>
                        <FNavLink FNavText="Estate Planning"/>
                    </div>
                </div>

                <div className='FCol'>
                    <p className='ColTitle'>Contact</p>
                    
                    <div className='FNav'>
                        <FNavLink FNavText="(555) 123-4567"/>
                        <FNavLink FNavText="contact@irongatelaw.com"/>
                        <FNavLink FNavText="123 Justice Boulevard"/>
                        <FNavLink FNavText="Suite 500"/>
                        <FNavLink FNavText="Legal District, LD 10101"/>
                    </div>
                </div>
            </div>

            <div className='FooterBottom'>
                <p>© 2026 Iron Gate Law. All rights reserved.</p>
                <p>Privacy Policy - Terms of Service</p>
            </div>
        </footer>
        </div>
     );
}
 
export default Home;